import {AnimTargetNodeTargetType} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/anim/Target';
import {AnimNodeEasing} from './../../../../../@polygonjs/polygonjs/src/core/animation/Constant';
import type {EventsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/EventsNetwork';
import type {PerspectiveCameraObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/PerspectiveCamera';
import type {AnimationsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/AnimationsNetwork';
import type {GeoObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/Geo';
import type {RootManagerNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
import type {ExampleData, DataCallbackOptions} from '../../Common';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();

	// const parentNode =root;

	// var nodesByRequestedName_2 = {}
	// var geo1 = geo/
	// var grid = parentNode.node('grid')
	// var hemisphereLight1 = parentNode.node('hemisphereLight1')
	// var perspectiveCamera1 = parentNode.node('perspectiveCamera1')
	// var COP = parentNode.node('COP')
	function create_geo1(parentNode: RootManagerNode) {
		var geo1 = parentNode.createNode('geo');
		geo1.setName('geo1');
		function create_ANIM(geo1: GeoObjNode) {
			const ANIM = geo1.createNode('animationsNetwork');
			ANIM.setName('ANIM');
			function create_CONTROLS(ANIM: AnimationsNetworkSopNode) {
				var CONTROLS = ANIM.createNode('play');
				CONTROLS.setName('CONTROLS');
				CONTROLS.uiData.setPosition(-150, 700);
				CONTROLS.params.postCreateSpareParams();
				CONTROLS.params.runOnSceneLoadHooks();

				CONTROLS.uiData.setComment(`By using the play/stop/rewind buttons of this node,
you will animate the copy node that is at the level above.

In this case, the animation is set to animate its parameter 'count',
which then animates the number of objects created.`);

				return CONTROLS;
			}
			function create_PLAY(ANIM: AnimationsNetworkSopNode) {
				var PLAY = ANIM.createNode('null');
				PLAY.setName('PLAY');
				PLAY.uiData.setPosition(0, 600);
				PLAY.params.postCreateSpareParams();
				PLAY.params.runOnSceneLoadHooks();
				return PLAY;
			}
			function create_RESET(ANIM: AnimationsNetworkSopNode) {
				var RESET = ANIM.createNode('null');
				RESET.setName('RESET');
				RESET.uiData.setPosition(-300, 600);
				RESET.params.postCreateSpareParams();
				RESET.params.runOnSceneLoadHooks();
				return RESET;
			}
			function create_duration1(ANIM: AnimationsNetworkSopNode) {
				var duration1 = ANIM.createNode('duration');
				duration1.setName('duration1');
				duration1.uiData.setPosition(0, 0);
				duration1.params.postCreateSpareParams();
				duration1.params.runOnSceneLoadHooks();
				return duration1;
			}
			function create_easing1(ANIM: AnimationsNetworkSopNode) {
				var easing1 = ANIM.createNode('easing');
				easing1.setName('easing1');
				easing1.uiData.setPosition(0, 100);
				easing1.setEasing(AnimNodeEasing.POWER2);
				easing1.params.postCreateSpareParams();
				easing1.params.runOnSceneLoadHooks();
				return easing1;
			}
			function create_propertyName1(ANIM: AnimationsNetworkSopNode) {
				var propertyName1 = ANIM.createNode('propertyName');
				propertyName1.setName('propertyName1');
				propertyName1.uiData.setPosition(0, 400);
				propertyName1.p.name.set('count');
				propertyName1.params.postCreateSpareParams();
				propertyName1.params.runOnSceneLoadHooks();
				return propertyName1;
			}
			function create_propertyValue1(ANIM: AnimationsNetworkSopNode) {
				var propertyValue1 = ANIM.createNode('propertyValue');
				propertyValue1.setName('propertyValue1');
				propertyValue1.uiData.setPosition(0, 500);
				propertyValue1.p.size.set(1);
				propertyValue1.p.value1.set(15);
				propertyValue1.params.postCreateSpareParams();
				propertyValue1.params.runOnSceneLoadHooks();
				return propertyValue1;
			}
			function create_propertyValue2(ANIM: AnimationsNetworkSopNode) {
				var propertyValue2 = ANIM.createNode('propertyValue');
				propertyValue2.setName('propertyValue2');
				propertyValue2.uiData.setPosition(-300, 500);
				propertyValue2.p.size.set(1);
				propertyValue2.params.postCreateSpareParams();
				propertyValue2.params.runOnSceneLoadHooks();
				return propertyValue2;
			}
			function create_target1(ANIM: AnimationsNetworkSopNode) {
				var target1 = ANIM.createNode('target');
				target1.setName('target1');
				target1.uiData.setPosition(0, 300);
				target1.setTargetType(AnimTargetNodeTargetType.NODE);
				target1.p.nodePath.set('../../copy1');
				target1.params.postCreateSpareParams();
				target1.params.runOnSceneLoadHooks();
				return target1;
			}
			var CONTROLS = create_CONTROLS(ANIM);
			var PLAY = create_PLAY(ANIM);
			var RESET = create_RESET(ANIM);
			var duration1 = create_duration1(ANIM);
			var easing1 = create_easing1(ANIM);
			var propertyName1 = create_propertyName1(ANIM);
			var propertyValue1 = create_propertyValue1(ANIM);
			var propertyValue2 = create_propertyValue2(ANIM);
			var target1 = create_target1(ANIM);
			CONTROLS.setInput(0, RESET);
			CONTROLS.setInput(1, PLAY);
			PLAY.setInput(0, propertyValue1);
			RESET.setInput(0, propertyValue2);
			easing1.setInput(0, duration1);
			propertyName1.setInput(0, target1);
			propertyValue1.setInput(0, propertyName1);
			propertyValue2.setInput(0, propertyName1);
			target1.setInput(0, easing1);
			ANIM.childrenController?.selection.add([propertyValue1]);
			ANIM.uiData.setPosition(-400, 300);
			ANIM.params.postCreateSpareParams();
			ANIM.params.runOnSceneLoadHooks();
			return {ANIM, CONTROLS};
		}
		function create_box1(geo1: GeoObjNode) {
			var box1 = geo1.createNode('box');
			box1.setName('box1');
			box1.uiData.setPosition(-200, 0);
			box1.params.postCreateSpareParams();
			box1.params.runOnSceneLoadHooks();
			return box1;
		}
		function create_copy1(geo1: GeoObjNode) {
			var copy1 = geo1.createNode('copy');
			copy1.setName('copy1');
			copy1.uiData.setPosition(-200, 200);
			copy1.flags.display.set(true);
			copy1.p.count.set(1);
			copy1.p.t.x.set(1);
			copy1.p.r.x.set(7);
			copy1.p.scale.set(0.95);
			copy1.params.postCreateSpareParams();
			copy1.params.runOnSceneLoadHooks();
			return copy1;
		}
		const ANIM = create_ANIM(geo1);
		var box1 = create_box1(geo1);
		var copy1 = create_copy1(geo1);
		copy1.setInput(0, box1);
		geo1.uiData.setPosition(-50, -150);
		geo1.flags.display.set(true);
		geo1.params.postCreateSpareParams();
		geo1.params.runOnSceneLoadHooks();
		return {geo1, ...ANIM};
	}
	function create_grid(parentNode: RootManagerNode) {
		var grid = parentNode.createNode('geo');
		grid.setName('grid');
		function create_planeHelper1(grid: GeoObjNode) {
			var planeHelper1 = grid.createNode('planeHelper');
			planeHelper1.setName('planeHelper1');
			planeHelper1.uiData.setPosition(0, 0);
			planeHelper1.flags.display.set(true);
			planeHelper1.params.postCreateSpareParams();
			planeHelper1.params.runOnSceneLoadHooks();
			return planeHelper1;
		}
		create_planeHelper1(grid);
		grid.uiData.setPosition(-50, -250);
		grid.flags.display.set(true);
		grid.params.postCreateSpareParams();
		grid.params.runOnSceneLoadHooks();
		return grid;
	}
	function create_hemisphereLight1(parentNode: RootManagerNode) {
		var hemisphereLight1 = parentNode.createNode('hemisphereLight');
		hemisphereLight1.setName('hemisphereLight1');
		hemisphereLight1.uiData.setPosition(150, 100);
		hemisphereLight1.flags.display.set(true);
		hemisphereLight1.params.postCreateSpareParams();
		hemisphereLight1.params.runOnSceneLoadHooks();
		return hemisphereLight1;
	}
	function create_perspectiveCamera1(parentNode: RootManagerNode) {
		var perspectiveCamera1 = parentNode.createNode('perspectiveCamera');
		perspectiveCamera1.setName('perspectiveCamera1');
		function create_events1(perspectiveCamera1: PerspectiveCameraObjNode) {
			var events1 = perspectiveCamera1.createNode('eventsNetwork');
			events1.setName('events1');
			function create_cameraOrbitControls1(events1: EventsNetworkSopNode) {
				var cameraOrbitControls1 = events1.createNode('cameraOrbitControls');
				cameraOrbitControls1.setName('cameraOrbitControls1');
				cameraOrbitControls1.uiData.setPosition(150, 50);
				cameraOrbitControls1.p.target.x.set(3.9625400379401956);
				cameraOrbitControls1.p.target.y.set(0.04817053372011402);
				cameraOrbitControls1.p.target.z.set(-0.41243246672712486);
				cameraOrbitControls1.params.postCreateSpareParams();
				cameraOrbitControls1.params.runOnSceneLoadHooks();
				return cameraOrbitControls1;
			}
			create_cameraOrbitControls1(events1);
			events1.uiData.setPosition(-200, 50);
			events1.params.postCreateSpareParams();
			events1.params.runOnSceneLoadHooks();
			return events1;
		}
		create_events1(perspectiveCamera1);
		perspectiveCamera1.uiData.setPosition(-200, 100);
		perspectiveCamera1.flags.display.set(true);
		perspectiveCamera1.p.t.x.set(3.6074898987970676);
		perspectiveCamera1.p.t.y.set(3.819513329169221);
		perspectiveCamera1.p.t.z.set(7.530044733696088);
		perspectiveCamera1.p.r.x.set(-25.364255830000126);
		perspectiveCamera1.p.r.y.set(-2.6336595742865265);
		perspectiveCamera1.p.r.z.set(-1.2479036576512519);
		perspectiveCamera1.p.controls.set('./events1/cameraOrbitControls1');
		perspectiveCamera1.params.postCreateSpareParams();
		perspectiveCamera1.params.runOnSceneLoadHooks();
		return perspectiveCamera1;
	}
	// function create_COP(parentNode:RootManagerNode){
	// 	var COP = parentNode.createNode('copNetwork')
	// 	COP.setName('COP')
	// 	function create_envMap(COP:CopNetworkObjNode){
	// 		var envMap = COP.createNode('envMap')
	// 		envMap.setName('envMap')
	// 		envMap.uiData.setPosition(50, 200)
	// 		envMap.params.postCreateSpareParams()
	// 		envMap.params.runOnSceneLoadHooks()
	// 		return envMap
	// 	}
	// 	function create_imageEnv(COP:CopNetworkObjNode){
	// 		var imageEnv = COP.createNode('imageEXR')
	// 		imageEnv.setName('imageEnv')
	// 		imageEnv.uiData.setPosition(50, 100)
	// 		imageEnv.params.get('url').set('https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master/textures/piz_compressed.exr')
	// 		imageEnv.params.postCreateSpareParams()
	// 		imageEnv.params.runOnSceneLoadHooks()
	// 		return imageEnv
	// 	}
	// 	function create_imageUv(COP:CopNetworkObjNode){
	// 		var imageUv = COP.createNode('image')
	// 		imageUv.setName('imageUv')
	// 		imageUv.uiData.setPosition(-100, 100)
	// 		imageUv.params.get('url').set('https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master/textures/uv.jpg')
	// 		imageUv.params.get('tflipY').set(true)
	// 		imageUv.params.postCreateSpareParams()
	// 		imageUv.params.runOnSceneLoadHooks()
	// 		return imageUv
	// 	}
	// 	var envMap = create_envMap(COP)
	// 	var imageEnv = create_imageEnv(COP)
	// 	var imageUv = create_imageUv(COP)
	// 	envMap.setInput(0, imageEnv, {"noExceptionOnInvalidInput":true})
	// 	COP.uiData.setPosition(-200, 200)
	// 	COP.params.postCreateSpareParams()
	// 	COP.params.runOnSceneLoadHooks()
	// 	return COP
	// }
	const {CONTROLS} = create_geo1(root);
	create_grid(root);
	create_hemisphereLight1(root);
	const perspectiveCamera1 = create_perspectiveCamera1(root);
	// return nodesByRequestedName_2

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [CONTROLS],
	};
}

// export const animTargetNode = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/anim/target/Animate Nodes`,
// 		createData,
// 		relatedNodes: [TargetAnimNode],
// 		categories: [ExampleCategory.ANIMATION],
// 	}),
// 	// new Example({name: `${ExamplePrefix.BY_CATEGORY}/animation/Node`, createData}),
// ];
